import styled from 'styled-components';

export const Container = styled.div`
  .main {
    display: flex;
    width: 100%;
    overflow-x: auto;
  }

  .header {
  }

  .footer {
  }
`;
